export const PeriodType = {
  Hours: 'Hours',
  Days: 'Days'
}

export const AppointmentsPeriodType = {
  Future: 'Future',
  Past: 'Past'
}
